import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ReceptionVisitHistoryPanel from '../../receptionist/panels/ReceptionVisitHistoryPanel';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';

export default function AdminReceptionPassagesPage() {
  const { toast } = useOutletContext();

  return (
    <>
      <ReportSectionHead
        badge="Réception"
        title="Journal des passages"
        description="Historique des visites accueil — filtres période, société, filière et export CSV."
      />
      <ReceptionVisitHistoryPanel
        toast={toast}
        hidePanelHeader
        panelTitle="Passages"
        panelSubtitle="Export CSV sur l’ensemble filtré."
      />
    </>
  );
}
